import { createSelector } from 'reselect';
import {
  entitySelector,
  entitiesSelector
} from 'helpers/entitySelector';

const classifiersEntities = (state) => state.db.entities;
const classifiersResults = (state) => state.db.result;

const getClassifiersSelector = createSelector(
  [classifiersEntities, classifiersResults],
  (entities, results)  => {
    const selectedClassifiers = entitiesSelector(entities, results, 'classifiers'),
          classifier = entitySelector(entities, results, 'classifierDetail'),
          clfWeightedTarget = entitySelector(entities, results, 'clfTarget'),
          filteredLabels = entitiesSelector(entities, results, 'filteredLabels'),
          textDetectorResults = entitiesSelector(entities, results, 'textDetectorResults'),
          videoDetectorResults = entitiesSelector(entities, results, 'videoDetectorResults'),
          boxDetectorResults = entitiesSelector(entities, results, 'boxDetectorResults'),
          savedWeightedTarget = entitySelector(entities, results, 'savedWeightedTarget'),
          savedMTurkEvaluator = entitySelector(entities, results, 'savedMTurkEvaluator'),
          savedTurkQaEnabled = entitySelector(entities, results, 'savedTurkQaEnabled'),
          turkQaEnabled = entitySelector(entities, results, 'turkQaEnabled'),
          mturkEvaluator = entitySelector(entities, results, 'mturkEvaluator');
    return {
      selectedClassifiers,
      classifier,
      filteredLabels,
      clfWeightedTarget,
      textDetectorResults,
      videoDetectorResults,
      boxDetectorResults,
      savedWeightedTarget,
      turkQaEnabled,
      mturkEvaluator,
      savedMTurkEvaluator,
      savedTurkQaEnabled
    };
  }
);

export default getClassifiersSelector;



// WEBPACK FOOTER //
// ./src/components/classifier/classifier.selector.jsx